// Settlements that are neither a win nor a loss.
//
// The server delivers them as an ordinary zero envelope, so without this table
// `won: false` renders DEFEAT plus the sandbox copy: wrong on both counts for a
// ranked match that simply never got confirmed. Keyed on the arbitration reason
// so a future neutral outcome is one more entry, not another branch.
//
// ONE table, read by both halves. The result modal renders from it, and the
// local stats cache treats exactly these reasons as "record nothing". Splitting
// them lets the modal say one thing while the hub counter says another, which
// is the bug this table was extracted to prevent: a client-side zero envelope
// keeps its `won` flag, so a suppressed counter under a VICTORY banner is the
// same contradiction one branch over.

export const NEUTRAL_ARBITRATION = {
  // Server: a lone win claim nobody corroborated, timed out.
  unverified_lone_win_no_contest: {
    banner: 'NO CONTEST',
    body: "The result couldn't be confirmed with your opponent. No rewards or rating changes were applied.",
  },
  // Client: the report POST threw. Only NETWORK-level failures are queued for
  // a later drain (matchReporting.js savePendingReport); a 4xx/5xx throws
  // straight out without an outbox entry. Both land here and the copy cannot
  // tell them apart, so it states what is true at this moment and promises
  // nothing about a retry that may never happen.
  report_failed: {
    banner: 'NOT RECORDED',
    body: 'We could not confirm this result with the server. No rewards or rating changes were applied.',
  },
  // Client: no roomCode, so submitReport returns before reportMatchOutcome is
  // ever called. Nothing is sent and nothing is queued, so this one is
  // definitively terminal.
  no_room_code: {
    banner: 'NOT RECORDED',
    body: 'This match window expired before the result could be reported. No rewards or rating changes were applied.',
  },
};

export function neutralArbitration(reason) {
  return NEUTRAL_ARBITRATION[reason] || null;
}
